/**
 * commandCenter 提案审批子模块
 *
 * 管理提案的批准/拒绝操作和加载状态。
 */
import { logger } from '@/utils'
import { ref } from 'vue'

/**
 * 创建提案审批子模块的状态和操作
 */
export function useProposalSlice() {
  // ===== State =====
  const proposalLoading = ref(false)
  const proposalError = ref<string | null>(null)

  // ===== Actions =====

  /** 批准提案 */
  async function approveProposal(proposalId: string): Promise<void> {
    proposalLoading.value = true
    proposalError.value = null
    try {
      const { proposalsApi } = await import('@/api/proposals')
      await proposalsApi.approve(proposalId)
    } catch (error) {
      const message = error instanceof Error ? error.message : '提案审批失败'
      proposalError.value = message
      logger.error('[CommandCenter] 批准提案失败:', error)
    } finally {
      proposalLoading.value = false
    }
  }

  /** 拒绝提案 */
  async function denyProposal(proposalId: string, reason?: string): Promise<void> {
    proposalLoading.value = true
    proposalError.value = null
    try {
      const { proposalsApi } = await import('@/api/proposals')
      await proposalsApi.deny(proposalId, reason)
    } catch (error) {
      const message = error instanceof Error ? error.message : '提案拒绝失败'
      proposalError.value = message
      logger.error('[CommandCenter] 拒绝提案失败:', error)
    } finally {
      proposalLoading.value = false
    }
  }

  return {
    // State
    proposalLoading,
    proposalError,
    // Actions
    approveProposal,
    denyProposal,
  }
}
